import GraphqlAPI from './graphql';

export default GraphqlAPI;
